import { configureFileReviewApi } from '@jarvis/platform-file-review';
import { apiFetch, readErrorMessage, readJson } from '../api/client';

let configured = false;

export function bootstrapFileReviewApi(): void {
  if (configured) return;
  configured = true;
  configureFileReviewApi({ apiFetch, readJson, readErrorMessage });
}
